<script lang="ts" setup>
const { data: faq } = await useLazyFetch('/api/faq')
const { data: faqCategories } = await useLazyFetch('/api/faq-categories')

const faqByCategory = computed(() => {
  return (
    faq.value?.reduce(
      (
        acc: Record<
          number,
          { title: string; qnas: { question: string; answer: string }[] }
        >,
        item
      ) => {
        if (!acc[item.faqCategoryId]) {
          acc[item.faqCategoryId] = {
            title:
              faqCategories.value?.find(
                (category) => category.id === item.faqCategoryId
              )?.title || 'Bez titulku',
            qnas: [],
          }
        }

        acc[item.faqCategoryId].qnas.push(item)

        return acc
      },
      {}
    ) || []
  )
})
</script>

<template>
  <div>
    <UiSection
      class="relative bg-[url(/img/grape_pozadi_sede.png)] bg-repeat"
      v-for="item in faqByCategory"
    >
      <div
        class="mx-auto mb-5 w-fit rounded-full bg-sky-600 px-8 py-3 font-medium text-white"
      >
        {{ item.title }}
      </div>
      <div class="mx-auto mb-5 flex max-w-4xl flex-col gap-5">
        <div
          v-for="qna in item.qnas"
          class="rounded-3xl bg-white p-5 shadow-[0_0px_10px_0px_rgba(0,0,0,0.05)]"
        >
          <p class="mb-2 font-bold">{{ qna.question }}</p>
          <HTMLRenderer :content="qna.answer" class="font-extralight" />
        </div>
      </div>
    </UiSection>
  </div>
</template>
